import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type {
  ProductImageRequest,
  ProductImageResponse,
  ProductRequest,
  ProductResponse,
} from '@/types/product';

export const productsApi = {
  list: (params?: SearchParams & { categoryId?: number; brandId?: number }) =>
    unwrap(api.get<ApiResponse<PageResponse<ProductResponse>>>('/v1/products', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<ProductResponse>>(`/v1/products/${id}`)),

  getByBarcode: (barcode: string) =>
    unwrap(api.get<ApiResponse<ProductResponse>>(`/v1/products/barcode/${encodeURIComponent(barcode)}`)),

  create: (body: ProductRequest) =>
    unwrap(api.post<ApiResponse<ProductResponse>>('/v1/products', body)),

  update: (id: number, body: ProductRequest) =>
    unwrap(api.put<ApiResponse<ProductResponse>>(`/v1/products/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/products/${id}`)),

  activate: (id: number, active: boolean) =>
    unwrap(
      api.patch<ApiResponse<ProductResponse>>(`/v1/products/${id}/activate`, null, {
        params: { active },
      }),
    ),

  listImages: (productId: number) =>
    unwrap(api.get<ApiResponse<ProductImageResponse[]>>(`/v1/products/${productId}/images`)),

  addImage: (productId: number, body: ProductImageRequest) =>
    unwrap(api.post<ApiResponse<ProductImageResponse>>(`/v1/products/${productId}/images`, body)),

  updateImage: (productId: number, imageId: number, body: ProductImageRequest) =>
    unwrap(
      api.put<ApiResponse<ProductImageResponse>>(
        `/v1/products/${productId}/images/${imageId}`,
        body,
      ),
    ),

  deleteImage: (productId: number, imageId: number) =>
    unwrap(api.delete<ApiResponse<null>>(`/v1/products/${productId}/images/${imageId}`)),
};
